import React from 'react';

/**
 * A lightweight inline skeleton for route transitions.
 * Less jarring than full-page LoadingScreen - keeps header/nav visible.
 */
export const RouteSkeleton: React.FC = () => {
  return (
    <div className="w-full max-w-5xl mx-auto py-8 space-y-6 animate-pulse">
      {/* Title skeleton */}
      <div className="h-8 w-48 bg-slate-200/60 rounded-lg" />

      {/* Card skeletons */}
      <div className="space-y-4">
        {[1, 2, 3].map(i => (
          <div key={i} className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 space-y-4">
            {/* Header */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-slate-200/80" />
              <div className="space-y-2 flex-1">
                <div className="h-4 w-32 bg-slate-200/80 rounded" />
                <div className="h-3 w-24 bg-slate-100 rounded" />
              </div>
            </div>
            {/* Content */}
            <div className="space-y-2">
              <div className="h-4 w-full bg-slate-100 rounded" />
              <div className="h-4 w-3/4 bg-slate-100 rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RouteSkeleton;
